import React from 'react';
import styles from './Admissions.module.css';
import admissionsHero from '../../assets/images/gallery_4.jpg';

const STEPS = [
  { num: '01', icon: '📝', title: 'Submit Enquiry', desc: 'Fill out our online enquiry form or visit our campus to express your interest in joining VIN Fly Aviation Academy.', note: 'Form available online 24/7' },
  { num: '02', icon: '📞', title: 'Free Counselling', desc: 'Attend a free counselling session with our career experts to understand which course suits you best.', note: '30-minute personal consultation' },
  { num: '03', icon: '📁', title: 'Document Verification', desc: 'Submit required documents for verification. Our team will review and confirm your eligibility.', note: '12th marksheet, Aadhaar, photos, birth certificate' },
  { num: '04', icon: '📊', title: 'Entrance Assessment', desc: 'Take a simple entrance assessment to evaluate your communication skills and aptitude.', note: 'Helps us customize your training path' },
  { num: '05', icon: '💳', title: 'Fee Payment', desc: 'Complete the admission process by paying the course fees. Flexible payment options available.', note: 'EMI available via SBI, Union Bank, HDFC' },
];

const FEE_ROWS = [
  { course: 'Air Hostess Training', duration: '12 Months', tuition: 'Contact Us', exam: 'Included', total: 'Flexible EMI Available' },
  { course: 'Airport Management', duration: '12 Months', tuition: 'Contact Us', exam: 'Included', total: 'Flexible EMI Available' },
  { course: 'Customer Service Executive', duration: '12 Months', tuition: 'Contact Us', exam: 'Included', total: 'Affordable Pricing' },
];

const Admissions = () => {
  return (
    <main>
      {/* Hero */}
      <section className="page-hero" data-theme="dark">
        <img src={admissionsHero} alt="Admissions" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }} />
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(to right, rgba(0,0,0,0.7), rgba(0,0,0,0.3))', zIndex: 0 }} />
        <div className="container page-hero__content">
          <p className="page-hero__breadcrumb">HOME / ADMISSIONS</p>
          <h1 className="page-hero__title">
            <span className="page-hero__title-top" style={{ color: '#FFFFFF', opacity: 1 }}>ADMISSIONS</span>
            <span className="page-hero__title-bottom" style={{ color: 'var(--cyan)' }}>OPEN.</span>
          </h1>
          <p className="page-hero__sub">
            Take the first step towards your dream aviation career. Limited seats available!
          </p>
        </div>
      </section>

      {/* 5 Steps */}
      <section className={`section-py ${styles.stepsSection}`}>
        <div className="container">
          <p className="label reveal">PROCESS</p>
          <h2 className="section-title reveal" style={{ marginTop: 12, marginBottom: 60 }}>Admission <span className="accent">Process.</span></h2>
          <div className={styles.stepsGrid}>
            {STEPS.map((s, i) => (
              <div key={s.num} className={`${styles.stepCard} dark-card reveal reveal-delay-${(i % 3) + 1}`}>
                <div className={styles.stepTop}>
                  <span className={styles.stepNum}>{s.num}</span>
                  <span className={styles.stepIcon}>{s.icon}</span>
                </div>
                <h3 className={styles.stepTitle}>{s.title}</h3>
                <p className={styles.stepDesc}>{s.desc}</p>
                {s.note && <div className={styles.stepNote}>{s.note}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Fees */}
      <section className={`section-py ${styles.fees}`}>
        <div className="container">
          <p className="label reveal">FEES</p>
          <h2 className="section-title reveal" style={{ marginTop: 12, marginBottom: 12 }}>Fee <span className="accent">Structure.</span></h2>
          <p className={`${styles.feeSub} reveal`}>Affordable education with flexible payment options. Contact us for detailed fee structure.</p>
          <div className={styles.tableWrap}>
            <table className={styles.table}>
              <thead>
                <tr className={styles.tableHead}>
                  <th>Course</th><th>Duration</th><th>Course Fee</th><th>Includes</th><th>Payment Options</th>
                </tr>
              </thead>
              <tbody>
                {FEE_ROWS.map((r, i) => (
                  <tr key={r.course} className={i % 2 === 0 ? styles.rowAlt : ''}>
                    <td className={styles.tdCourse}>{r.course}</td>
                    <td className={styles.td}>{r.duration}</td>
                    <td className={styles.td}>{r.tuition}</td>
                    <td className={styles.td}>{r.exam}</td>
                    <td className={`${styles.td} ${styles.totalTd}`}>{r.total}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className={styles.scholarship}>
            <p className={styles.scholarTitle}>🎓 PAYMENT PLANS</p>
            <p className={styles.scholarBody}>Basic Plan: Standard course fee with flexible payment options | Premium Plan: Full package with personality development and interview prep | Installment Plan: Easy monthly EMI options available</p>
          </div>
          <p className={styles.feeNote}>* Fees are subject to revision. Contact contact@vinaviation.com for current pricing.</p>
        </div>
      </section>

      {/* Application Section — Zoho Embedded Form */}
      <section className={styles.formSection}>
        {/* Decorative clouds */}
        <div className={styles.cloud1} />
        <div className={styles.cloud2} />
        <div className={styles.cloud3} />

        {/* Airplane SVG watermark */}
        <svg className={styles.planeSvg} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M60 4L4 28l20 8 8 20L60 4z" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round" />
          <path d="M24 36l8-8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>

        <div className="container">
          <p className="label reveal" style={{ textAlign: 'center' }}>APPLY NOW</p>
          <h2 className="section-title reveal" style={{ marginTop: 12, marginBottom: 16, textAlign: 'center' }}>
            Start Your <span className="accent">Application.</span>
          </h2>
          <p className={`${styles.appSubtitle} reveal`}>Fill out the form below to begin your aviation journey</p>

          <div className={`${styles.formBox} reveal`}>
            <iframe
              src="https://forms.zohopublic.in/vinflyaviationacademy1/form/AdmissionInquiryfrom/formperma/V2QuQqnDjF5c9UPIMPbrruVOtRC_W48NPISG0PaJ3lo"
              width="100%"
              height="950px"
              frameBorder="0"
              title="Admission Inquiry Form"
              style={{ border: 'none' }}
              id="admission-zoho-form"
            />
          </div>

          <div className="reveal" style={{ textAlign: 'center', marginTop: '20px', marginBottom: '10px' }}>
            <p style={{ fontSize: '13px', color: 'var(--text-muted)', marginBottom: '10px' }}>
              Form not loading?
            </p>
            <a
              href="https://forms.zohopublic.in/vinflyaviationacademy1/form/AdmissionInquiryfrom/formperma/V2QuQqnDjF5c9UPIMPbrruVOtRC_W48NPISG0PaJ3lo"
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 24px', borderRadius: '100px', fontSize: '14px', fontWeight: 'bold', background: 'var(--blue)', color: '#fff', textDecoration: 'none', boxShadow: '0 4px 14px rgba(26,115,232,0.3)' }}
            >
              Open Form in New Tab ↗
            </a>
          </div>

          <div className={`${styles.appPhoneRow} reveal`} style={{ marginTop: 24 }}>
            <span className={styles.appPhoneLabel}>Prefer to call? Reach us at:</span>
            <a href="tel:+919960555941" className={styles.appPhoneLink}>+91 9960 555 941</a>
            <span className={styles.appPhoneSep}>·</span>
            <a href="tel:+919960555942" className={styles.appPhoneLink}>+91 9960 555 942</a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Admissions;
